import { render } from "./TheHeader.vue?vue&type=template&id=6858be24&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=6858be24&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6858be24"

export default script